import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/73f4f224/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentDemo = makeShortcode("ComponentDemo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Progress indicator`}</h2>
    <ComponentDemo links={{
      React: 'https://react.carbondesignsystem.com/?path=/story/progressindicator--default',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-progress-indicator--basic',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvprogress--default',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=progress-indicator'
    }} knobs={{
      ProgressStep: ['complete', 'current', 'disabled', 'invalid'],
      ProgressIndicator: ['vertical']
    }} mdxType="ComponentDemo">
  {`
  <div className="some-container">
    <ProgressIndicator currentIndex={1}>
        <ProgressStep
          label="First step"
          description="Step 1: Getting started with Carbon Design System"
        />
        <ProgressStep
          current
          label="Second step with tooltip"
          description="Step 2: Getting started with Carbon Design System"
          renderLabel={() => (
            <Tooltip
              direction="bottom"
              showIcon={false}
              triggerClassName="bx--progress-label"
              triggerText="Second step with tooltip"
              tooltipId="tooltipId-0">
              <p>Second step with tooltip</p>
            </Tooltip>
          )}
        />
        <ProgressStep
          label="Third step"
          description="Step 3: Getting started with Carbon Design System"
          secondaryLabel="Optional label"
        />
        <ProgressStep
          invalid
          label="Fourth step"
          description="Step 4: Getting started with Carbon Design System"
        />
        <ProgressStep
          disabled
          label="Fifth step"
          description="Step 5: Getting started with Carbon Design System"
        />
      </ProgressIndicator>
  </div>
`}
    </ComponentDemo>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      